import { Paper } from "@mui/material";
import PairAddRecordsFilter from "./PairAddRecordsFilter";
import PairAddRecordsTable from "./PairAddRecordsTable";

const tableHeadings = {
  fme: "FME",
  date: "Date",
  fme_income: "FME Income",
  policy_fme_income: "Policy FME Income",
  manual_fme_income: "Manual FME Income",
  linked: "Linked",
  covered: "% Covered",
  fme_status: "FME Status",
  account: "Account",
  brands: "Brands",
};
const rows = [
  {
    fme: ["5325"],
    date: "25/07/25",
    fme_income: "180.34",
    policy_fme_income: "171.37",
    manual_fme_income: "174.35",
    linked: "Yes",
    covered: "100%",
    fme_status: "Invoice Unrequited",
    account: "jonathan@optival.com",
    brands: ["megacasino"],
  },
  {
    fme: ["5325"],
    date: "25/07/25",
    fme_income: "180.34",
    policy_fme_income: "171.37",
    manual_fme_income: "174.35",
    linked: "No",
    covered: "100%",
    fme_status: "Approved For Invoice",
    account: "jonathan@optival.com",
    brands: ["megacasino"],
  },
  {
    fme: ["5325"],
    date: "25/07/25",
    fme_income: "180.34",
    policy_fme_income: "171.37",
    manual_fme_income: "174.35",
    linked: "Yes",
    covered: "100%",
    fme_status: "Dispute",
    account: "jonathan@optival.com",
    brands: ["megacasino",'brsport','casinocasino'],
  },
  {
    fme: ["5325"],
    date: "25/07/25",
    fme_income: "180.34",
    policy_fme_income: "171.37",
    manual_fme_income: "174.35",
    linked: "Yes",
    covered: "100%",
    fme_status: "Initial",
    account: "jonathan@optival.com",
    brands: ["megacasino",'brsport','casinocasino'],
  },
  {
    fme: ["5325"],
    date: "25/07/25",
    fme_income: "180.34",
    policy_fme_income: "171.37",
    manual_fme_income: "174.35",
    linked: "",
    covered: "100%",
    fme_status: "Bad Debts",
    account: "jonathan@optival.com",
    brands: ["megacasino",'brsport','casinocasino'],
  },
  
];

const PairAddRecords = () => {
  return (
    <>
      <Paper sx={{ mt: 1 }}>
        <PairAddRecordsFilter />
        <PairAddRecordsTable tableHeadings={tableHeadings} rows={rows} />
      </Paper>
    </>
  );
};

export default PairAddRecords;
